/**
 * Search criteria for the Govex member-search page.
 * Govex users cannot be suppliers, so supplier-specific filters
 * (business types, payments, subscription type, etc.) are intentionally omitted.
 */
export class GovexMemberSearchRequestDTO {
  // Base infos
  userId: number | null;
  loginId: string;
  firstName: string;
  lastName: string;
  email: string;
  ipAddress: string;

  // Company infos
  companyName: string;
  vatNumber: string;
  phone: string;
  zipString: string;
  language: number | null;

  // User group and status
  userGroupId: number | null;
  status: number | null;
  blockReason: number | null;

  // Affiliates
  affiliateIds: number[] | [];

  // Govex-specific
  userTypeProfile: number | null;
  govexProfileId: number | null;
  cpv2008: string;
  workcat: string;
  govexStatuses: number[] | [];
  regionsNotIn: number[] | [];

  constructor(data?: any) {
    this.userId = data?.userId ?? null;
    this.loginId = data?.loginId ?? '';
    this.firstName = data?.firstName ?? '';
    this.lastName = data?.lastName ?? '';
    this.email = data?.email ?? '';
    this.ipAddress = data?.ipAddress ?? '';

    this.companyName = data?.companyName ?? '';
    this.vatNumber = data?.vatNumber ?? '';
    this.phone = data?.phone ?? '';
    this.zipString = data?.zipString ?? '';
    this.language = data?.language ?? null;

    this.userGroupId = data?.userGroupId ?? null;
    this.status = data?.status ?? null;
    this.blockReason = data?.blockReason ?? null;

    this.affiliateIds = data?.affiliateIds ?? [];

    this.userTypeProfile = data?.userTypeProfile ?? null;
    this.govexProfileId = data?.govexProfileId ?? null;
    this.cpv2008 = data?.cpv2008 ?? '';
    this.workcat = data?.workcat ?? '';
    this.govexStatuses = data?.govexStatuses ?? [];
    this.regionsNotIn = data?.regionsNotIn ?? [];
  }
}
